<!-- @@User Timeline @@-->
<!-- <app-profile-left></app-profile-left> -->
<!--@@ START MIDDILE PART @@-->
  <div class="row margin-top-22px">
    <div class="col-lg-8 pr-md-0">
      <div class="row">
        <div class="col-lg-4 pr-md-0 d-none d-lg-block">
        <div class="sticky-top top-86px">
        <app-profile-left>
        </app-profile-left>
        </div>
        </div>
        <div class="col-lg-8">
          <div (click)="grandroundFilters()"
            id="timelineView"
            [ngClass]="{'grandround-arrow': funCollectionService.device_detail.is_desktop}"
            class="timeline-container"
            infiniteScroll
            [infiniteScrollDistance]="numbers.TWO"
            [infiniteScrollThrottle]="numbers.FIFTY"
            [infiniteScrollDisabled]="busyGettingData"
            (scrolled)="onScrollDown()"
            [scrollWindow]="true" >
            <!-- {{feedMixList.msg}} -->
            <div *ngIf="filterDataInfo" class="py-2">
              <p class="paragraph-bold">
                <img alt="back icon"
                  class="page-back-arrow cursor-pointer"
                  src="assets/themes/icons/back-arrow.svg"
                  (click)="backToPrevious()">
                  <span class="color-grey-700">{{mls.languageText.grandround.key2}}</span>
              </p>
            </div>
            <div *ngIf="filterDataInfo && selectedSpecialty"
              class="pr-3 py-2 mb-2 paragraph-bold">
              <img src="assets/themes/icons/hashtag-svg.svg" class="mr-2" alt="hashtag">
              <span class="color-grey-700">#{{selectedSpecialty}}</span>
            </div>
            <ng-container>
              <div *ngIf="(render && pvsFlag) && (this.mls.featureOnOffList.featureList.pvs.value || !mls.userLoginFlow)" class="promo-strip">
                <app-promo-strip [currentScreenName]="funCollectionService?.currentScreename" [startTime]="pvsData.start_time"  [endTime]="pvsData.end_time" [pvsId] = "pvsData.pvs_id" (hideStrip)="closePPs()" [pvsHtml]="pvsHtml" [closeType]="pvsData.close_cta_type"></app-promo-strip>
              </div>
            </ng-container>
                        <!-- Story Start -->
                        <div *ngIf="(this.mls.featureOnOffList.featureList.userStory.value || !mls.userLoginFlow)">
                        <app-nudges-modal [isNudgeModal]="false"></app-nudges-modal>
                        <div *ngIf="!isStoriesOpen && userStoryList?.length > 0 && checkForFilter()" class="bg-white container-shadow mb-3 px-3 pt-3 pb-2 custom-owl-carousel">
                          <owl-carousel-o [options]="customOptionsForStoriesList" *ngIf="userStoryList?.length" (translated)="getStoryList($event)" #owlCarousel>
                            <ng-template *ngFor="let story of userStorySer.storyThumbnail;trackBy:trackByFn; let i = index" [id]="getCarouselId(i)" carouselSlide [width]="132" >
                              <div class="overflow-hidden border-radius-8">
                                <app-thumbnail-views [isCreationMode]="false" [youText]="mls.languageText.stories_tutorial.key32" [isMe]="story.type === 'ME' ? true : false " [listing]="true" class="story-thumbnail cursor-pointer"[backGroundImage]="story.carouselCode !='' ? story.carouselCode : 'assets/images/grandround/image_placeholder.svg'"[thumbnailInfo]="story" [activeStatus]="isStoriesAvailable(story)" noInfoSrc = 'assets/images/no-story.svg' (click)="openStory(story.uuid, i)"></app-thumbnail-views>
                              </div>
                              </ng-template>
                          </owl-carousel-o>
                          <app-no-info-available *ngIf="!userStoryList?.length" noInfoSrc="assets/images/no-story.svg" [noInfoType]="NO_STORIES_TYPE.STORY_LIST" class="w-100" [noInfoHeading]="mls.languageText.no_stories.key1" [noInfoParagraph]="mls.languageText.no_stories.key2"></app-no-info-available>
                        </div>

                        <div *ngIf="!isStoriesOpen && userStoryList?.length === 0 && storyListOffset === 0 && checkForFilter()" class="bg-white container-shadow mb-3 px-3 pt-3 pb-2 d-flex">
                          <div>
                            <img src="assets/images/no-stories-default.png" alt="no-stories">
                          </div>
                          <div class="ml-3 my-auto">
                            <p class="fnt-size16px fnt-weight500 mb-1">{{mls.languageText.no_stories.key1}}</p>
                            <span class="mt- d-inline-block">{{mls.languageText.no_stories.key2}}</span>
                          </div>
                        </div>
                        <div *ngIf="isStoriesOpen" class="story-carousel">
                          <span class="d-none d-md-block story-carousel-heading text-white">
                            <h2 class="heading-2 text-white">{{mls.languageText.stories.key1}}</h2>
                          </span>
                          <!-- d-none d-sm-block -->
                          <span class="story-carousel-cross d-none d-md-block" (click)="closeStories()">
                            <img src="assets/images/story-cross.svg" alt="cross">
                          </span>
                          <div *ngIf="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid) && userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid); else storyFail" class="d-flex justify-content-center align-items-center w-100 h-100">
                            <app-stories
                              class="w-100"
                              [stories]="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid)?.value"
                              [uuid]="userStorySer.currentStoryUuid"
                              [autoStart]="true"
                              [currentPlaying]="true"
                              [activeStoryIndex]="activeStoryIndex"
                              (onAllStoriesEnd)="onAllStoriesEnd($event)"
                              (onStoryDelete)="onStoryDelete($event)"
                              (onGoBack)="isStoriesOpen = false"
                              (emitCtaTarget)="onCtaClick($event)"
                              (onStoryChange)="onStoryChange($event)"
                              (logViewStory)="logViewStory($event)"
                              (emitdeeplinkRedirection)="deeplinkRedirection($event)"
                              (emitStoryView)="logStoryView($event)"
                              (emitClose)="closeStories()"
                              (headerRedirect)="headerRedirection($event)"
                              [loadingState]="userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid)">
                            </app-stories>
                          </div>
                            <ng-template #storyFail>
                              <div  class="d-flex justify-content-center align-items-center w-100 h-100">
                                <app-stories
                                [stories]="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid)"
                                [uuid]="userStorySer.currentStoryUuid"
                                [autoStart]="true"
                                [currentPlaying]="true"
                                [activeStoryIndex]="activeStoryIndex"
                                (onAllStoriesEnd)="onAllStoriesEnd($event)"
                                (onGoBack)="isStoriesOpen = false"
                                (emitClose)="closeStories()"
                                (onStoryChange)="onStoryChange($event)"
                                (emitdeeplinkRedirection)="deeplinkRedirection($event)"
                                [loadingState]="userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid)" class="w-100" [autoStart]="true" [currentPlaying]="true" (onAllStoriesEnd)="onAllStoriesEnd($event)"></app-stories>
                              </div>
                            </ng-template>
                        </div>
                        <app-story-tutorial [youText]="mls.languageText.stories_tutorial.key32" [centerImage]="storyIntroCenterImage" [userStoryList]="userStoryList" [storyTutorialStep]="storyTutorialStep" [secondaryButtonText]="secondaryButtonTextIntro" [primaryButtonText]="primaryButtonTextIntro" [introducingText]="mls.languageText.stories_tutorial.key18" [storiesText]="mls.languageText.stories_tutorial.key19" [newText]="mls.languageText.stories_tutorial.key29" [paragraphText]="storyIntroParagraphText" (emitHidden)="onIntroHide()"  (emitNextStep)="nextStep($event)" *ngIf="isStoryIntroEnabled && userStoryList?.length > 0"></app-story-tutorial>
                        </div>
                        <!-- Story End -->
            <div *ngIf="feedMixList.length==numbers.ZERO && finishedFilter==false && finished==true"
              class="text-center pt-2">{{mls.languageText.feed_list.key1}}
              <span *ngIf="mls?.is_lskey_display == numbers.ONE">(feed_list.key1)
              </span>
            </div>
            <div *ngFor="let feedList of feedMixList; let index=index" >
              <ng-container *ngIf="feedList.product_type === productTypeCarousal">
                <div *ngIf="feedList.products[0].type === type" class="p-3 bg-white container-shadow">
                  <app-public-community-card
                    (emitViewAll)="navigateToCommunityList()"
                    (emitCommunityDetail)="emitPublicCommunityDetail($event)"
                    [community]="communityList"
                    [translations]="publicTranslations"
                    [screenFrom]= "callFrom"
                    [callFromScreen] = "callFrom"
                    [pOffset]="pOffset">
                  </app-public-community-card>
                </div>
                <div class="p-3 bg-white container-shadow" *ngIf="feedList.products[0].type === myCommunityCarousel ">
                  <app-public-community-card
                    [community]="myCommunity"
                    [translations]="publicTranslations"
                    [screenFrom]= "callFrom"
                    [callFromScreen] = "callFrom"
                    [pOffset]="pOffset"
                    [carouselType]="myCommunityCarousel"
                    (emitCommunityDetail)="emitPublicCommunityDetail($event)">
                  </app-public-community-card>
                </div>
              </ng-container>
              <div class="hcf-carousal custom-owl-carousel mb-3 p-0" *ngIf="feedList.product_type === productType.HCF">
                <app-hcf-outer *ngIf="feedList.products[numbers.ZERO].product_type === productType.HCF"
                  [outerInfo]="{
                    product_type: feedList.products[numbers.ZERO].product_type,
                    product_type_id: feedList.products[numbers.ZERO].product_type_id,
                    title: feedList.products[numbers.ZERO].title,
                    subtitle: feedList.products[numbers.ZERO].subtitle,
                    target: feedList.products[numbers.ZERO].target}"
                    appear
                    [appearIds]="getAppearedIds(feedList.products[numbers.ZERO])"
                    (appearedCards)="onCardAppear($event)"
                    (emitOuterCardTarget)="hcfOuterCardTarget(feedList.products[numbers.ZERO].product_type, feedList.products[numbers.ZERO].product_type_id)"
                    (emitCtaTarget)="hcfOuterCtaTarget($event, feedList.products[numbers.ZERO].product_type, feedList.products[numbers.ZERO].product_type_id)">
                    <div [ngClass]="{'mr-3' : feedList.products[numbers.ZERO].list?.length === numbers.TWO && feedList.products[numbers.ZERO].product_type_id === hcfproductTypeId.CONTINUE_WATCH }">
                      <owl-carousel-o [options]="hcfContinueWatchOption(feedList.products[numbers.ZERO].draw_pattern)">
                        <ng-template *ngFor="let hcfInfo of feedList.products[numbers.ZERO].list | hcfTemplateFilter" carouselSlide>
                            <app-hcf-template
                              appear
                              [appearIds]="getAppearedIds(hcfInfo)"
                              (appearedCards)="onCardAppear($event)"
                              [horizontal]="true"
                              [template]="hcfInfo.template"
                              [templateInfo]="hcfInfo.info"
                              [buttonLabel]="(hcfInfo.info.target && hcfInfo.info.target.text) ? hcfInfo.info.target.text : hcfConnectionLabel"
                              [productCount]="feedList?.products[numbers.ZERO]?.list?.length"
                              [playTime]="hcfPlayTime(hcfInfo?.info?.time?.total)"
                              (emitCardTarget)="hcfCardTarget($event, hcfInfo, feedList?.products[numbers.ZERO]?.product_type_id)"
                              (emitCtaTarget)="hcfCtaTarget($event, hcfInfo)">
                            </app-hcf-template>
                        </ng-template>
                      </owl-carousel-o>
                    </div>
                </app-hcf-outer>
              </div>
              <ng-container
                *ngIf="feedList.product_type === productType.NCP &&
                feedList.products[0]?.type === ncpProductSubType.HEALTH_CARD">
                <app-healthcard
                  appear
                  [appearIds]="getAppearedIds(feedList.products[0])"
                  (appearedCards)="onCardAppear($event)"
                  [product]="feedList">
                </app-healthcard>
              </ng-container>
              <ng-container
                *ngIf="feedList.product_type === productType.NCP &&
                  feedList.products[0]?.type !== ncpProductSubType.HEALTH_CARD">
                <app-ncp-card
                  appear
                  [appearIds]="getAppearedIds(feedList.products[0])"
                  (appearedCards)="onCardAppear($event)"
                  [callingFrom]="callingfrom"
                  [product]="feedList">
                </app-ncp-card>
              </ng-container>

              <!--Feed card-->
              <ng-container *ngIf="feedList.product_type == productType.FEED" >
                <div *ngFor="let data of feedList.products;" [id]="feedList?.text_highlight+ '-' + 'Card'" class="mb-3">
                  <app-feed-card
                    appear
                    [appearIds]="getAppearedIds(data)"
                    [callingfrom]="callingfrom"
                    (deleteFeedIdx) = deleteFeedIdx($event)
                    [feedObj]="data"
                    [source]="1"
                    [ptoductType]="feedList.product_type"
                    [feedIdx]="index"
                    [textHeighlight]="feedList?.text_highlight"
                    [flags]="flags"
                    (appearedCards)="onCardAppear($event)"
                    (feedSpecialty)="feedListFilteredBySpecialty($event)">
                  </app-feed-card>
                </div>
              </ng-container>

              <!-- user not verified card-->
              <div *ngIf="feedList.product_type==33 " >
                <div class="mb-3" *ngFor="let data of feedList.products;">
                  <app-verify-process
                    [callingfrom]="callingfrom"
                    [dataObj]="data">
                  </app-verify-process>
                </div>
              </div>

              <!-- posting card-->
              <div *ngIf="feedList.product_type==productType.POSTING_CARD" >
                <div class="mb-3" *ngFor="let data of feedList.products;">
                  <app-posting-card
                    [dataObj]="data"
                    [isPostButtonDisable]="isPostButtonDisable">
                  </app-posting-card>
                </div>
              </div>

              <!--posting process card start-->
              <div *ngIf="feedList.product_type==productType.POSTING_CARD">
                <app-post-processing
                  *ngIf="dss.feed_post_in_process?.is_show==true"
                  [feed_post_in_process]="dss.feed_post_in_process"
                  [userctivity]="userctivity"
                  (resetUploadComplete)="resetUploadComplete($event)">
                </app-post-processing>
              </div>
              <!--posting process card end-->

              <!--Editor choice card invoke start-->
              <div *ngIf="feedList.product_type === productType.EDITORS_CHOICE">
                <app-editor-choice-card
                  appear
                  [appearIds]="getAppearedIds(feedList)"
                  [editorChoiceCard]="feedList"
                  [callingfrom]="ecScreenName"
                  [ecIdx]="index"
                  (feedSpecialty)="feedListFilteredBySpecialty($event)"
                  (appearedCards)="onCardAppear($event)"
                  (feedSpecialtyInnerCard)="innerCardSelectedSpecialty($event)">
                </app-editor-choice-card>
              </div>
              <!--Editor choice card invoke end-->

              <!--@@ START JOURNAL POST @@-->
              <ng-container *ngIf="feedList?.product_type == productType.ARTICLE "  > 
                <div [id]="feedList?.text_highlight+ '-' +feedList?.products[0]?.product_type_id "class="mb-3 container-shadow">
                  <div class="px-3 py-2 top-border-radius separator-line-btm"
                    [ngClass]="{'d-flex justify-content-between':
                    feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE}"
                    [style.background-image]="feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE &&
                    feedList.products[0]?.editor_choice_data.headers?.color | gradient: gradientDirection.BOTTOM">
                      <p class="secondary-paragraph-bold" [ngClass]="{
                        'ellipsis': feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE}">
                        <img src="assets/themes/icons/gr/clinical-case.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                        <ng-container *ngIf="feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE">
                          <span class="mr-0 ec-badge d-flex align-items-center">
                            <img loading="lazy" class="ec-badge-icon" [src]='feedList.products[0].editor_choice_data.headers?.images.icon' alt="ec badge icon"/>
                            <span class="ec-text ec-text-overflow secondary-paragraph"
                              [title]="feedList.products[0].editor_choice_data.headers?.highlight_text">
                              <span class="color-grey-700">{{feedList.products[0].editor_choice_data.headers?.highlight_text}}</span>
                            </span>
                          </span>
                        </ng-container>
                  </div>
                  <div class="p-3">
                  <div *ngFor="let data of feedList.products;" >
                      <app-clinical-resource-card
                        appear
                        [appearIds]="getAppearedIds(data)"
                        [callingfrom]="callingfrom"
                        [clinicalObj]="data"
                        [idx]="index"
                        (feedSpecialty)="feedListFilteredBySpecialty($event)"
                        (appearedCards)="onCardAppear($event)">
                      </app-clinical-resource-card>
                  </div>
                </div>
                </div>
              </ng-container>
              <!--@@ END JOURNAL POST @@-->

              <!-- START EVENT POST-->
              <div *ngIf="feedList.product_type == productType.EVENT && feedList?.mode_of_product == 'offline'">
                <div  [id]="feedList?.text_highlight+ '-'+'Card'" class="mb-3 container-shadow">
                  <div class="px-3 py-2">
                    <p class="secondary-paragraph-bold">
                      <img src="assets/themes/icons/gr/offline-event.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                  <div class="separator-line"></div>
                  <div class="p-3">
                    <ng-container *ngFor="let data of feedList.products;">
                      <app-web-events-card
                        appear
                        [appearIds]="getAppearedIds(data)"
                        [eventTracker]='{"category":mls.googleEventText.grandround.category,"action":mls.googleEventText.grandround.key8,"product_type":"7", "product_id":""}'
                        [eventListing]="data"
                        (appearedCards)="onCardAppear($event)">
                      </app-web-events-card>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- END EVENT POST -->


              <!--@@ START CME POST @@-->
              <ng-container *ngIf="feedList.product_type == productType.CME ">
                <div [id]="feedList?.text_highlight+ '-'+'Card'"class="mb-3 container-shadow bg-white">
                  <div class="px-3 py-2">
                    <p class="secondary-paragraph-bold">
                      <img src="assets/themes/icons/gr/cme.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                  <div class="separator-line"></div>
                  <ng-container *ngFor="let data of feedList.products;">
                    <app-web-cme-card
                      appear
                      [appearIds]="getAppearedIds(data)"
                      [callingfrom]="callingfrom"
                      [cmeObj]="data"
                      (feedSpecialty)="feedListFilteredBySpecialty($event)"
                      (appearedCards)="onCardAppear($event)">
                    </app-web-cme-card>
                  </ng-container>
                </div>
              </ng-container>
              <!--@@ END CME POST @@-->

              <!-- @@ START BANNER POST@@ -->
              <div *ngIf="feedList.product_type == productType.BANNER" class="mb-3 custom-owl-carousel banner-card-carousel p-0">
                <owl-carousel-o  [options]="customOptions" >
                  <ng-template *ngFor="let data of feedList.products;" carouselSlide >
                    <app-banner-card
                      appear
                      [horizontal]="true"
                      [rootMargin]="funCollectionService.margin.bannerCurrentHRootMargin"
                      [appearIds]="getAppearedIds(data)"
                      (appearedCards)="onCardAppear($event)"
                      [callingfrom]="callingfrom"
                      [feedObj]="data"
                      [productType]="productType.BANNER">
                    </app-banner-card>
                  </ng-template>
                </owl-carousel-o>
              </div>
              <!-- @@ end BANNER POST@@ -->

              <!--@@ START CHANNEL POST @@-->
              <div *ngIf="feedList.product_type == productType.CHANNEL ">
                <div class="mb-3 container-shadow bg-white">
                  <div class="p-2">
                    <p class="secondary-paragraph-bold clearfix">
                      <img src="assets/themes/icons/gr/channels.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span>
                    <span (click)="navigateToChannel()"
                      class="btn-design small outline  float-right">View All</span>
                    </p>
                  </div>
                  <div class="separator-line"></div>

                  <div class="p-3 custom-owl-carousel">
                    <owl-carousel-o
                      [options]="sliderwebinarOptions"
                      *ngIf="'fdsfs' !='explore_phrm'">
                      <ng-template carouselSlide *ngFor="let data of feedList.products;">
                          <app-web-channel-card
                            appear
                            [appearIds]="getAppearedIds(data)"

                            [docCardObj]='data'
                            [docTalkSection]='docTalkObj?.section_key'
                            [listLength]='docTalkObj?.list?.length'
                            (appearedCards)="onCardAppear($event)">
                          </app-web-channel-card>
                      </ng-template>
                    </owl-carousel-o>
                  </div>
                </div>
              </div>
              <!--@@ END CHANNEL POST @@-->

              <!--@@ START DRUGSAMPLE POST @@-->
              <div *ngIf="feedList.product_type == productType.DRUG ">
                <div class="mb-3  container-shadow bg-white">
                  <div class="px-3 py-2 secondary-paragraph-bold separator-line-btm">
                    <p class="color-grey-700">
                      <img src="assets/themes/icons/drug-sampal.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                  <div *ngFor="let data of feedList.products;">
                    <div>
                      <app-drug-sample-card
                        appear
                        [appearIds]="getAppearedIds(data)"
                        [callingfrom]="callingfrom"
                        [is_ordered]=0
                        [drugListObj]='data'
                        [type]="order"
                        (appearedCards)="onCardAppear($event)">
                      </app-drug-sample-card>
                    </div>
                  </div>
                </div>
              </div>
              <!--@@ END DRUGSAMPLE POST @@-->

              <!--@@ START CME POST @@-->
              <div *ngIf="feedList.product_type == productType.DOCTALKS ">
                <div [id]="feedList?.text_highlight+ '-'+'Card'" class="mb-3 container-shadow bg-white">
                  <div class="px-3 py-2 secondary-paragraph-bold separator-line-btm">
                    <p class="color-grey-700">
                      <img src="assets/themes/icons/gr/doctalks.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                  <div class="p-3" *ngFor="let data of feedList.products;">
                    <app-web-doctalk-card
                      appear [appearIds]="getAppearedIds(data)"
                      [callingfrom]="callingfrom"
                      [docCardObj]='data'
                      [docTalkSection]='"features_videos"'
                      [listLength]=2
                      (appearedCards)="onCardAppear($event)">
                    </app-web-doctalk-card>
                  </div>
                </div>
              </div>
              <!--@@ END CME POST @@-->

              <!--@@ START CONNECTION @@-->
              <ng-container *ngIf="feedList.product_type == productType.CONNECTION ">   
                <div  [id]="feedList?.text_highlight+ '-' +feedList?.product_type" class="mb-3 container-shadow bg-white">
                  <div class="px-3 py-2">
                    <p class="secondary-paragraph-bold">
                      <img src="assets/themes/icons/gr/connections.svg" class="mr-2"/>
                        <span class="color-grey-700">{{feedList.text_highlight}}</span>
                    </p>
                  </div>
                  <div class="separator-line"></div>
                  <div class="px-3">
                    <div class="py-3 separator-line-btm" *ngFor="let data of feedList.products; let isLast = last">
                      <app-connection-card
                        [callingfrom]="callingfrom"
                        [usercardsize]="'m'" [suggObj]="data">
                      </app-connection-card>
                    </div>
                  </div>
                  <div class="px-3">
                    <div class="text-center py-3">
                      <p class="d-flex align-items-center justify-content-center">
                        <span class="cursor-pointer fnt-weight500"
                          (click)="navigateToConnection()"><span class="button">View All</span>
                        </span>
                        <img src="assets/themes/icons/right-arorrow.svg" width="20" class="pl-1" alt="arrow">
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!--@@ END CONNECTION @@-->

              <!--@@ START WEBINAR @@-->
              <ng-container *ngIf="feedList.product_type == productType.WEBINAR ">
                <div [id]="feedList?.text_highlight +'-'+ 'Card'" class="mb-3 container-shadow bg-white">
                  <div class="secondary-paragraph-bold px-3 py-2">
                    <p class="color-grey-700 d-flex align-items-center">
                      <img src="assets/themes/icons/gr/webinar.svg"
                        class="mr-2"
                        width="25px"/> <span class="color-grey-700">{{feedList.text_highlight}}</span> </p>
                  </div>
                  <div class="separator-line"></div>
                  <div class="p-3">
                    <ng-container *ngFor="let data of feedList.products;">
                      <app-webinar-card
                        appear
                        [appearIds]="getAppearedIds(data)"
                        [callingfrom]="callingfrom"
                        [docCardObj]='data'
                        [docTalkSection]=''
                        [listLength]=1
                        (appearedCards)="onCardAppear($event)">
                      </app-webinar-card>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <!--@@ END WEBINAR @@-->


              <!--@@ START WEBINAR @@-->
              <div *ngIf="feedList.product_type == productType.SURVEY ">
                <div class="mb-3 container-shadow bg-white">
                  <div class="px-3  py-2">
                    <p class="secondary-paragraph-bold">
                      <img src="assets/themes/icons/gr/surveys.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                  <div class="separator-line"></div>
                  <div class="p-3">
                    <ng-container *ngFor="let data of feedList.products;">
                      <app-survey-feed-card
                        appear
                        [appearIds]="getAppearedIds(data)"
                        [callingfrom]="callingfrom"
                        [surveyObj]="data"
                        (appearedCards)="onCardAppear($event)">
                      </app-survey-feed-card>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!--@@ END WEBINAR @@-->

              <!--@@ START news POST @@-->
              <div *ngIf="feedList.product_type==20 ">
                <div class="mb-3 container-shadow bg-white">
                  <div class="p-3">
                    <p class="paragraph-bold"><span class="color-grey-700">{{feedList.text_highlight}}</span></p>
                  </div>
                </div>
              </div>
              <!--@@ END CME POST @@-->

              <!-- START DRUG POST CAROUSEL -->
              <div *ngIf="feedList.product_type==39 ">
                <div [id]="feedList?.text_highlight +'-'+ 'nudge-'+feedList?.product_type" class="mb-3 container-shadow bg-white">
                  <div class="px-3 py-2 secondary-paragraph-bold separator-line-btm">
                    <p class="color-grey-700 clearfix">
                      <img src="assets/themes/icons/drug-sampal.svg" class="mr-2" width="25px"/><span class="color-grey-700">{{feedList.text_highlight}}</span>
                      <span (click)="viewAllDrugs(feedList.products, 0)"
                        class="btn-design small outline float-right">View All</span>
                    </p>
                  </div>
                  <div class="custome-chip-carosel">
                    <div class="gender-form p-3">
                      <div class="custom-owl-carousel p-0 gender-form position-relative header-search-main">
                        <owl-carousel-o  [options]="customOptionsNudge">
                          <ng-template *ngFor="let data of feedList.products; let Index = index " carouselSlide>
                            <span [ngClass]="{'filter-chip':Index === drugIndex}"
                              (click)="applyDrugCategory(Index, data)" class="chip-container">
                              <span type="radio" name="radio1" id="male">
                              </span>
                              <label id="nudge-chip" class="chip small outline"
                              for="male">{{data.title}}
                              </label>
                          </span>
                          </ng-template>
                        </owl-carousel-o>
                      </div>
                    </div>
                  </div>
                  <div class="custom-owl-carousel px-3 pb-3 pt-0">
                    <owl-carousel-o [options]="sliderwebinarOptions">
                      <ng-template carouselSlide *ngFor="let drugData of feedList.products[drugIndex].therapeutic_drugs;" >
                        <span>
                          <app-edetail-drug-card
                            appear
                            [horizontal]="true"
                            [rootMargin]="funCollectionService.margin.drugCurrentHRootMargin"
                            [appearIds]="getAppearedIds(drugData)"
                            (appearedCards)="onCardAppear($event)"
                            [drugData]="drugData"
                            [speciality]='feedList.products[drugIndex]'
                            (viewDrugDetail)=viewDrugDetail($event)>
                          </app-edetail-drug-card>
                        </span>
                      </ng-template>
                    </owl-carousel-o>
                  </div>
                </div>
              </div>
              <!-- END DRUG POST CAROUSEL -->

              <!-- START DRUG POST CAROUSEL -->
              <div *ngIf="feedList.product_type == productType.PHARMA">
                <div [id]="feedList?.text_highlight+ '-'+'nudge'" class="mb-3 container-shadow bg-white">
                  <div class="secondary-paragraph-bold px-3 py-2 separator-line-btm">
                    <p class="color-grey-700 d-flex align-items-center justify-content-between">
                      {{feedList.text_highlight}}
                      <button (click)="viewAllPharmas()"
                        class="btn-design small outline">
                        View All
                      </button>
                    </p>
                  </div>
                  <div class="custom-owl-carousel-drug">
                  <div class="custom-owl-carousel px-3 pt-3 pb-md-0 pb-3">
                    <owl-carousel-o [options]="sliderwebinarOptions">
                      <ng-template carouselSlide *ngFor="let pharmaData of feedList.products;" >
                        <app-edetail-pharma-card
                          (click)="viewPharma(pharmaData)"
                          [callingFrom]="'gr'"
                          [pharmaData]="pharmaData">
                        </app-edetail-pharma-card>
                      </ng-template>
                    </owl-carousel-o>
                  </div>
                  </div>
                </div>
              </div>
              <!-- END DRUG POST CAROUSEL -->

              <!-- START community GR card -->
              <ng-container class="community-gr" *ngIf="feedList.product_type === productType.COMMUNITY">
                <div class="mb-3 bg-trannsparent">
                  <app-single-community-card
                    [community]="feedList?.products[0]"
                    [callingFrom]="callingfrom">
                  </app-single-community-card>
                </div>
              </ng-container>
              <!-- END community GR card -->
            </div>
          </div>
            <!--Loaders start-->
          <div *ngIf="!finished" class='text-center mt-4'>
            <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post" />
          </div>
            <!--Loaders end-->

            <!--Loaders filter start-->
          <div *ngIf="finishedFilter==true && finished" class='text-center mt-4'>
            <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post">
          </div>
          <!--Loaders filter end-->
        </div>
      </div>
    </div>
    <div class="col-lg-4 d-none d-lg-block">
      <div>
        <app-suggestion-right
          [product_type]="1"
          [profileObj]="profileObj"
          [verificationData]="verificationData">
        </app-suggestion-right>
      </div>
    </div>
  </div>
  <!--@@ END POST MIDDILE PART @@ -->

  <!-- chat sidebar -->
  <!-- @@ START RIGHT PART   @@-->
  <!-- <app-suggestion-right *ngIf="verificationData!=undefined" [product_type]=1 [profileObj]=profileObj [verificationData]="verificationData"></app-suggestion-right> -->

  <!-- @@ END RIGHT PART @@ -->
  <!--@@ END USER TIME LINE @@-->

  <app-edetail-modal
    *ngIf="showViewAllDrug"
    [showModal]='showViewAllDrug'
    [modalType]='"viewAll"'
    [logo]=''
    [title]="'Drugs'"
    (backClicked)='backClicked()'
    [callingFrom]="callingfrom" >
    <div class="ps position-relative post-modal-max-height"
      [perfectScrollbar]=""
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onScrolldrugs()"
      [scrollWindow]="false">
      <div class="gender-form px-3">
        <span [ngClass]="{'filter-chip': drugSpeciality.etpm_id === speciality.value}"
          *ngFor="let speciality of therapeuticFilterList"
            (click)="applyViewAllSpeciality(speciality)">
            <span type="radio" name="radio1" id="male">
            </span>
            <label class="chip small outline mr-3"
              for="male">{{speciality.name}}
            </label>
        </span>
      </div>

      <div class="row m-0" *ngIf="drugListData !== undefined">
        <div class="col-lg-4 col-md-6 col-12 mb-3 px-1" *ngFor="let productData of  drugListData; let idx = index ">
          <app-edetail-drug-card
            [drugData]="productData"
            [speciality]='drugSpeciality'
            (viewDrugDetail)=viewDrugDetail($event)>
          </app-edetail-drug-card>
        </div>
        <div class="col-12">
          <div *ngIf="drugListData.length === numbers.ZERO && viewAllDrugLoader === false" class="p-3 text-center">
            <img src="assets/themes/icons/no-data-found.svg" alt="no-data-found">
            <p class="heading-4 pt-3">{{mls.languageText.edetail.key17}}</p>
          </div>
        </div>
        <div  class='text-center col-md-12' *ngIf="viewAllDrugLoader === true">
          <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post" />
        </div>
      </div>
    </div>
  </app-edetail-modal>
